import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { SsOnboardingService } from 'shared/services/SS-Onboard/ss-onboarding.service';
import { Inject } from '@angular/core';
import { UserService } from 'shared/services/User/user.service';

@Component({
  selector: 'app-connect-team-modal',
  templateUrl: './connect-team-modal.component.html',
  styleUrls: ['./connect-team-modal.component.css']
})
export class ConnectTeamModalComponent implements OnInit {
  teamAccountForm: FormGroup;
  loading: boolean;

  constructor(
    public dialogRef: MatDialogRef<ConnectTeamModalComponent>,
    private router: Router,
    private groupService: GroupService,
    private alertService: AlertPopupService,
    private data: DataSharingService,
    private onboarding: SsOnboardingService,
    private us: UserService,
    @Inject(MAT_DIALOG_DATA) private params: any
  ) { }

  ngOnInit() {
    this.teamAccountForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.minLength(10)]),
      password: new FormControl('', [Validators.required, Validators.minLength(4)])
    });
  }

  connectTeamAccount() {
    this.loading = true;
    this.onboarding.connectTeamAccount(this.teamAccountForm.value, this.params.teamId).subscribe(res => {
      this.us.reloadUser().then(response => {
        // reload user to update team auths in cookie
        this.loading = false;
        this.alertService.errorAlertSuccess('Successfully linked your Team Account. Your tickets will be digitally available after the Game Draft. Click Purchase to proceed.');
        this.dialogRef.close();
      });
    }, err => {
      console.log(err);
      this.loading = false;
      this.alertService.errorAlert('Invalid team account credentials. Please try again using a different email or password. ');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/connect-team-modal/connect-team-modal.component.ts